module.exports = __webpack_public_path__ + "assets/img/27_1468.3def18a3.jpg";